import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useFeature } from '../lib/features';

// Shown in place of a screen whose feature a ZMAP admin has switched off.
export function FeatureOff() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 px-6 py-24 text-center">
      <h1 className="text-lg font-semibold">This feature is currently turned off</h1>
      <p className="text-sm text-black/60 dark:text-white/60">It isn't available right now. Please check back later.</p>
      <Link to="/" className="text-sm text-blue-600 hover:underline dark:text-blue-400">
        Back to Zmist
      </Link>
    </div>
  );
}

// Renders children only while `feature` is on (see lib/features.ts); otherwise
// the fallback, which defaults to the "turned off" page. For hiding a piece
// of UI rather than a whole screen, pass fallback={null}.
export function FeatureGate({ feature, fallback, children }: { feature: string; fallback?: ReactNode; children: ReactNode }) {
  const on = useFeature(feature);
  if (on) return <>{children}</>;
  return <>{fallback === undefined ? <FeatureOff /> : fallback}</>;
}
